<suite-rfb-collapse [title]="titulo">
    <div *ngIf="(infoObservable$ | async) as info; else loadingOrError">
        <!-- pre>info: {{info | json }}</pre -->
        <div class="container-fluid">
            <!-- Section: Identificação -->
            <section class="section-custom">
                <h2 class="section-title">Identificação Pessoa Jurídica</h2>
                <div class="row fileira-gradeada">
                  <div class="col-md-3">
                    <label class="label-formulario control-label">CNPJ Matriz</label>
                    <p class="form-control-static dado-formulario">
                      {{ info.cnpj | formatCnpjPipe }}
                    </p>
                  </div>
                  <div class="col-md-9">
                    <label class="label-formulario control-label"
                      >Nome</label
                    >
                    <p class="form-control-static dado-formulario">
                      {{ info.razaoSocial | vazio }}
                    </p>
                  </div>
                </div>
            </section>
 
            <section class="section-custom">
                <h2 class="section-title">Informações Estabelecimento</h2>
                <div class="row fileira-gradeada">
                    <div class="col-md-5">
                        <label class="label-formulario control-label">Unidade da Receita do Domicílio Fiscal</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.unidade | uaPipe | vazio }}
                        </p>    
                    </div>    
                    <div class="col-md-4">
                        <label class="label-formulario control-label">Situação no CNPJ</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.situacaoCadastral | vazio }}
                        </p>    
                    </div>    
                    <div class="col-md-3">
                        <label class="label-formulario control-label">Abertura Empresa/Entidade</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.dataAbertura | date: 'shortDate' | vazio }}
                        </p>    
                    </div>    
                </div>    

                <div class="row fileira-gradeada">
                    <div class="col-md-5">
                        <label class="label-formulario control-label">Responsável/Titular perante o CNPJ</label>
                        <p class="form-control-static dado-formulario">
                            <ni-com-link [ni]="info.responsavel.cpf" [nome]="info.responsavel.nome"></ni-com-link>
                        </p>    
                    </div>    
                    <div class="col-md-4">
                        <label class="label-formulario control-label">Situação do Responsável na Base CPF</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.responsavel.situacaoCadastral | vazio }}
                        </p>    
                    </div>    
                    <div class="col-md-3">
                        <label class="label-formulario control-label">Qualificação do Responsável</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.responsavel.qualificacao | vazio }}
                        </p>    
                    </div>    
                </div>    
                <div class="row fileira-gradeada">
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Preposto da Empresa</label>
                        <p *ngIf="possuiPreposto; else semPreposto" class="form-control-static dado-formulario">
                            {{ info.preposto.cpf | formatCpfPipe }} - {{ info.preposto.nome }}
                        </p>
                        <ng-template #semPreposto>
                            <p class="form-control-static dado-formulario">
                                -
                            </p>
                        </ng-template>
                    </div>    
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Porte da Empresa</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.codigoPorteEmpresa | porteEmpresaPipe | vazio }}
                        </p>    
                    </div>    
                </div>    
                <div class="row fileira-gradeada">
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Natureza Jurídica da Empresa/Entidade</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.naturezaJuridica.codigo }}-{{ info.naturezaJuridica.numeroDv }} {{ info.naturezaJuridica.nome }}
                        </p>
                    </div>
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Atividade Econômica da Matriz</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.atividadeEconomica | subclasseCnaePipe | vazio }}
                        </p>
                    </div>
                </div>

                <div class="row fileira-gradeada">
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Acompanhamento Diferenciado em</label>
                        <p class="form-control-static dado-formulario">
                            {{ acompanhamentoDiferenciado | vazio:[]:info.anoAcompanhamentoDiferenciado }}
                        </p>
                    </div>
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Obrigado a DCTF Mensal em</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.anoInteresseDctf | vazio:["0000,0000,0000,0000,0000"] }}
                        </p>
                    </div>
                </div>

                <div class="row fileira-gradeada">
                    @if (info.cnpjAdquirente) {
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Motivo</label>
                        <p *ngIf="possuiMotivoSituacao; else semMotivoSituacao" class="form-control-static dado-formulario">
                            {{ info.motivoBaixa | vazio }}
                        </p>
                        <ng-template #semMotivoSituacao>
                            <p class="form-control-static dado-formulario">
                                -
                            </p>
                        </ng-template>
                    </div>
                    <div class="col-md-6">
                        @if (exibeAdquirente) {
                        <label class="control-label label-formulario">
                            CNPJ Adquirente
                        </label>
                        <p class="form-control-static dado-formulario">
                            <ni-com-link [ni]="info.cnpjAdquirente"></ni-com-link>
                        </p>
                        }
                        @else {
                        <label class="control-label label-formulario">
                            Ente Federativo Responsável
                        </label>
                        <p class="form-control-static dado-formulario">
                            {{ info.codigoEnteFederativoResponsavel | vazio }}
                        </p>
                        }
                    </div>
                    }
                    @else {
                    <div class="col-md-12">
                        <label class="label-formulario control-label">Motivo</label>
                        <p *ngIf="possuiMotivoSituacao; else semMotivoSituacao" class="form-control-static dado-formulario">
                            {{ info.motivoBaixa | vazio }}
                        </p>
                        <ng-template #semMotivoSituacao>
                            <p class="form-control-static dado-formulario">
                                -
                            </p>
                        </ng-template>
                    </div>
                    }
                </div>
            </section>

            <section class="section-custom">
                <h2 class="section-title">Endereço Estabelecimento</h2>
                <div class="row fileira-gradeada">
                    @if (residenteNoBrasil) {
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Endereço</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco | enderecoInfoCadPipe | vazio }}
                        </p>
                    </div>
                    <div class="col-md-6">
                        <label class="label-formulario control-label">Bairro</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco.bairro | vazio }}
                        </p>
                    </div>
                    }
                    @else {
                    <div class="col-md-12">
                        <label class="label-formulario control-label">Endereço</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco | enderecoInfoCadPipe | vazio }}
                        </p>
                    </div>
                    }
                </div>
                <div class="row fileira-gradeada">
                    @if (residenteNoBrasil) {
                    <div class="col-md-4">
                        <label class="label-formulario control-label">Município</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco.municipio.nome | vazio }}
                        </p>
                    </div>
                    <div class="col-md-4">
                        <label class="label-formulario control-label">UF</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco.municipio.uf | vazio }}
                        </p>
                    </div>
                    <div class="col-md-4">
                        <label class="label-formulario control-label">CEP</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco.cep | cepPipe | vazio }}
                        </p>
                    </div>
                    }
                    @else {
                    <div class="col-md-12">
                        <label class="label-formulario control-label">Município</label>
                        <p class="form-control-static dado-formulario">
                            {{ info.endereco.municipio.nome | vazio }}
                        </p>
                    </div>
                    }
                </div>
            </section>    

            <div *ngIf="optanteSimei || optanteSimplesFederal || optanteSimplesNacional">
                <section class="section-custom">
                    <h2 class="section-title">Opções Pelo SIMPLES</h2>
                    <div *ngIf="optanteSimei">
                        <div class="row" style="border: none;">
                            <via-info-cadastrais-pj-table 
                                titulo="SIMEI" 
                                [opcoes]="info.simplesSimei">
                            </via-info-cadastrais-pj-table>
                        </div>        
                    </div>
                    <div *ngIf="optanteSimplesFederal">
                        <div class="row" style="border: none;">
                            <via-info-cadastrais-pj-table  
                                titulo="Simples Federal"
                                [opcoes]="info.simplesSF">
                            </via-info-cadastrais-pj-table>
                        </div>        
                    </div>
                    <div *ngIf="optanteSimplesNacional">
                        <div class="row" style="border: none;">
                            <via-info-cadastrais-pj-table 
                                titulo="Simples Nacional"
                                [opcoes]="info.simplesSN">
                            </via-info-cadastrais-pj-table>                
                        </div>    
                    </div>    
                </section>
            </div>    
        </div>
    </div>
</suite-rfb-collapse>

<ng-template #loadingOrError>
  <div *ngIf="loadingError$ | async; else loading">Ocorreu um erro...</div>
  <ng-template #loading>
    <loading-animation></loading-animation>
  </ng-template>
</ng-template>
